module.exports = __webpack_public_path__ + "assets/img/daily-report.b39b53e8.png";